import { create } from 'zustand';

export type TokenStore = {
  accessToken?: string;
  refreshToken?: string;
  accessTokenExpiration?: number;
  refreshTokenExpiration?: number;
  saveTokens: (data: {
    accessToken: string;
    accessTokenExpiration: number;
    refreshToken: string;
    refreshTokenExpiration: number;
  }) => void;
  clear: () => void;
};

export const useTokensStore = create<TokenStore>((set) => ({
  saveTokens: ({
    accessToken,
    accessTokenExpiration,
    refreshToken,
    refreshTokenExpiration,
  }) => {
    set({
      accessToken,
      accessTokenExpiration,
      refreshToken,
      refreshTokenExpiration,
    });
  },
  clear: () => {
    set({
      accessToken: undefined,
      accessTokenExpiration: undefined,
      refreshToken: undefined,
      refreshTokenExpiration: undefined,
    });
  },
}));
